import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import type { OpenApiSchemaNotification } from '#shared/api/schema';

const api = createApi({
    name: 'entities/notification/api/api',
    tagTypes: ['Notification'],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getLastNotification: builder.query<OpenApiSchemaNotification | null, void>({
                query: () => {
                    return {
                        url: '/notifications/notification',
                        method: 'GET',
                    };
                },
                transformResponse: (value: unknown): OpenApiSchemaNotification | null =>
                    value && typeof value === 'object' && 'id' in (value as object)
                        ? (value as OpenApiSchemaNotification)
                        : null,
                providesTags: ['Notification'],
            }),

            markNotificationAsRead: builder.mutation<unknown, string>({
                query: (notification_id) => {
                    return {
                        url: '/notifications/mark_read',
                        method: 'POST',
                        body: { notification_id },
                    };
                },
                async onQueryStarted(_arg, { queryFulfilled }) {
                    const patch = api.endpoints.getLastNotification.updateQueryData(undefined, () => null);

                    try {
                        await queryFulfilled;
                    } catch {
                        patch.undo();
                    }
                },
                invalidatesTags: ['Notification'],
            }),
        };
    },
});

export const { useLazyGetLastNotificationQuery, useMarkNotificationAsReadMutation } = api;
